import { axiosInstance } from "../utils";
import { IChapter, IDraftChapter } from "../models/wall";
import { ApiResponse } from "./wall";

export const getChaptersByStoryId = async (storyId: string): Promise<ApiResponse<IChapter>> => {
  const response = await axiosInstance.get<ApiResponse<IChapter>>(`/chapters/`, {
    params: {story: storyId}
  });

  return response.data;
}
export const createDraftFromChapterApi = async (chapterId: string): Promise<IDraftChapter> => {
  const response = await axiosInstance.post<IDraftChapter>(`/chapters/${chapterId}/create-draft/`);

  return response.data;
}

export const toggleHideChapterApi = async (id: string, isHidden: boolean): Promise<void> => {
  const response = await axiosInstance.patch(`/chapters/${id}/${isHidden ? "unhide" : "hide"}/`);
}

export const deleteChapterApi = async (id: string, isDraft?: boolean): Promise<void> => {
  const response = await axiosInstance.delete(`/${isDraft? "draft-chapters" : "chapters"}/${id}/`);
}
export const moveChapterUpApi = async (id: string): Promise<void> => {
  const response = await axiosInstance.patch(`/chapters/${id}/move-up/`);
}
export const moveChapterDownApi = async (id: string): Promise<void> => {
  const response = await axiosInstance.patch(`/chapters/${id}/move-down/`);
}
